import './DamageList.css';
import React from 'react';
import * as _ from 'lodash';
import axios from 'axios';
import {combineReducers} from 'redux';
import {connect} from 'react-redux';
import {Box} from 'reactjs-admin-lte';
import styled from 'styled-components';
import FixLevelConfig from '../../../../view/workdoc/fixlevel/FixLevelConfig'
import {OverlayTrigger,Popover} from 'react-bootstrap'
import $ from 'jquery';

import {
  Modal,
  Table,
  Row,
  Col,
  Form,
  FormControl,
  FormGroup,
  ControlLabel,
  Button,
  ButtonToolbar,
  SplitButton,
  MenuItem,
  Nav,
  NavItem,
  Panel,
} from 'react-bootstrap';
import FontAwsome from 'react-fontawesome';

import * as ReactDataGrid from 'react-data-grid';
import {Editors, Formatters} from 'react-data-grid-addons';

import {
  loadDamageData,
  updateDamageItemByRowIndex,
  addDamageItem,
  removeDamageItemByRowIndex,
} from '../../../../stores/CarDamage/DamageReducer';
import {
  setPartBy,
  updateCar,
} from '../../../../stores/CarDamage/CarReducer';

import CheckboxEditor from './../Editors/CheckboxEditor';
import WorkdocStore from '../../../../stores/WorkdocStore';
import Moment from 'moment/moment';

import AsyncAutoComplete from '../../../../component/element/AsyncAutoComplete';
import ConfirmPopup from '../../../../component/element/ConfirmPopup';
import NumericFormat from '../../../../component/element/NumericFormat';
import InputNumber from 'rc-input-number'
import Select from 'react-select'

const PaddedRow = styled(Row)`
  line-height: 40px;
`;

const StaticWidthNumeric = styled(NumericFormat)`
  display: inline-block;
  min-width: 150px;
`;

class DamageList extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      deleteDamageItemModal: false,
      deleteDamageItemMessage: '',
      deleteDamageItemRow: null,
      urlCache: {first:true,status:false,url:'',data:[]}
    };
  }

  componentDidMount() {
    $('body').on('click', ()=> { 
      if (this.props.car.view=='3') {
        if ($('.Select').hasClass('is-open'))
          $('.table-responsive').css( "overflow-x", "initial" );
        else
          $('.table-responsive').css( "overflow-x", "auto" );
      }
    });
    $('body').on('focus', '.form-detail', ()=> {
      $('.table-responsive').css( "overflow-x", "initial" );
    });
    $('body').on('click', '.form-detail', ()=> {
      $('.table-responsive').css( "overflow-x", "initial" );
    });
    $('body').on('keypress', '.form-detail', (e)=> {
      if (e.charCode==13)
        $('.table-responsive').css( "overflow-x", "auto" );
    });
    $('body').on('click', '.async-autocomplete-wrapper', ()=> {
      $('.table-responsive').css( "overflow-x", "auto" );
    });
  } 

  getDamageOptions() {
    const {props} = this;
    return _.map(props.wageList, (item) => {
      return {
        title: item.description,
        id: item.itemnum,
      };
    });
  }

  changeTableView = (e) => {
    this.props.dispatch(updateCar({view: e.target.value}))
  };

  onPartByChange = (e) => {
    const partBy = e.target.value;
    this.props.dispatch(setPartBy({partBy}));
  };

  dispatchResize = () => {
    setTimeout(() => window.dispatchEvent(new Event('resize')), 1000);
  };

  addNewDamageItem = (amount, item) => (e) => {
    item = Object.assign(item,{prefer_repair:'1'})
    this.props.dispatch(addDamageItem({amount, item}));
  };

  renderTableDataView1() {
    const {props} = this;
    const {dispatch} = props;

    if (this.props.car.view != 1) { return null; }

    return (
        <div className="table-responsive">
          <table
              className={'table table-bordered table-striped table-hover table-bordered-solid'}>
            <thead>
            <tr>
              <th className={'align-middle text-center'}
                  style={{width: '60px'}}
                  rowSpan={2}>ลำดับ
              </th>
              <th className={'align-middle'}
                  rowSpan={2}>รายการตรวจสอบความเสียหาย
              </th>
              <th className={'align-middle text-center'}
                  style={{width: '60px'}}
                  rowSpan={2}>เคาะ-พ่นสี
              </th>
              <th className={'align-middle text-center'}
                  style={{width: '60px'}}
                  rowSpan={2}>ซ่อม
              </th>
              <th className={'align-middle text-center'}
                  style={{width: '60px'}}
                  rowSpan={2}>อะไหล่เปลี่ยน
              </th>
              <th style={{width:'100px'}} className={'align-middle text-center'}
                  rowSpan={2}>จำนวน
              </th>
              <th className={'align-middle text-center'}
                  colSpan={2}>ราคาประเมินให้ประกัน/ลูกค้า
              </th>
              <th style={{width: '60px'}} className={'align-middle text-center'}
                  rowSpan={2}>ซ่อมจริง
              </th>
              <th style={{width: '50px'}} className={'align-middle text-center'}
                  rowSpan={2}>ลบ
              </th>
            </tr>
            <tr>
              <th style={{width:'120px'}} className={' text-center'}>ค่าแรง</th>
              <th style={{width:'120px'}} className={' text-center'}>ค่าอะไหล่</th>
            </tr>
            </thead>
            <tbody>
            {props.damageList.map(
                (item, index) => this.renderTableRow(item, index))}
            </tbody>
            {this.renderTableFooter()}
          </table>
          <Row>
            <Col md={6}>
              <Button bsStyle={'success'}
                      onClick={this.addNewDamageItem(1, {part_flag: 0})}>
                + เพิ่มรายการ
              </Button>
              {' '}
              <Button bsStyle={'success'}
                      onClick={this.addNewDamageItem(10, {part_flag: 0})}>
                + เพิ่ม 10 รายการ
              </Button>
            </Col>
            <Col md={6} className={'text-right'}>
              <Form inline>
                <FormGroup>
                  <ControlLabel>ผู้จัดการอะไหล่</ControlLabel>
                  {' '}
                  <FormControl componentClass="select"
                               value={this.props.car.partBy}
                               onChange={this.onPartByChange}>
                    <option value="garage">อู่</option>
                    <option value="branch">สาขา</option>
                    <option value="insurance">ประกัน</option>
                    <option value="customer">ลูกค้า</option>
                  </FormControl>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </div>
    );
  }

  renderTableFooter() {
    const {props} = this;
    const {dispatch, damageList} = props;
    const total_wage = damageList.reduce(
        (sum, item) => sum + (parseFloat(item.wage_cost) || 0), 0);
        // (sum, item) => sum + ((parseFloat(item.wage_cost) || 0) *
        //                       (parseFloat(item.quantity) || 0)), 0);
    const total_part = damageList.reduce(
        // (sum, item) => sum + ((parseFloat(item.part_cost) || 0) *
        //                       (parseFloat(item.quantity) || 0)), 0);
        (sum, item) => sum + (parseFloat(item.part_cost) || 0), 0);

    return (
        <tfoot>
        <tr>
          <th colSpan={6} className={'text-right'}>
            รวมราคา <NumericFormat>{(total_wage +
                                     total_part)}</NumericFormat> บาท
          </th>
          <th className={'text-right bg-yellow'}>
            <NumericFormat>{total_wage}</NumericFormat></th>
          <th className={'text-right bg-yellow'}>
            <NumericFormat>{total_part}</NumericFormat></th>
          <th></th>
          <th></th>
        </tr>
        </tfoot>
    );
  }

  handleDetailSelect(row, e) {

    const selected_item = e || {};
    const item_data = (e.ItemNum || '').split('/');
    const flag = item_data[0] || '';
    const itemnum = item_data[1] || '';
    let updated = {detail: selected_item.Value};
    
    switch (flag) {
      case 'W':
        updated['fix_flag'] = 1;
        updated['paint_flag'] = 0;
        updated['wage_itemnum'] = itemnum;

        break;
      case 'P':
        updated['part_flag'] = 1;
        updated['itemnum'] = itemnum;
        break;
    }

    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));

  }

  handleWagePriceSelect(row, e) {

    const selected_item = e || {};
    let wage_cost = selected_item.Price || 0;
    wage_cost = wage_cost.indexOf(',')!=-1?wage_cost.replace(/,/g, ''):wage_cost
    let updated = {wage_cost};

    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));

  }

  handlePartPriceSelect(row, e) {
    let {damageList} = this.props
    const selected_item = e || {};
    let part_cost = selected_item.Price || 0;
    part_cost = part_cost.indexOf(',')!=-1?part_cost.replace(/,/g, ''):part_cost
    this.handlePricePerUnit(row, part_cost)
    if (damageList[row].quantity>0)
      part_cost = part_cost*damageList[row].quantity
    let updated = {part_cost:part_cost,parts_flag:1};

    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));
  }

  handlePricePerUnitSelect(row, e) {

    const selected_item = e || {};
    let price_per_unit = selected_item.Price || 0;
    price_per_unit = price_per_unit.indexOf(',')!=-1?price_per_unit.replace(/,/g, ''):price_per_unit
    let updated = {price_per_unit};

    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));

  }

  handlePricePerUnit(row, price_per_unit) {
    let updated = {price_per_unit};

    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));

  }

  handlePartPrice(row, part_cost) {
    let updated = {part_cost};

    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));

  }

  handleNetWagePriceSelect(row, e) {
    const selected_item = e || {};
    const net_wage_cost = selected_item.Price || 0;
    let updated = {net_wage_cost};

    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));

  }

  removeDamageItem = () => {
    const row = this.state.deleteDamageItemRow;
    this.props.dispatch(removeDamageItemByRowIndex({row}));
    this.setState({
      deleteDamageItemModal: false,
    });
  };

  checkEmptyRow(row) {
    const check_fields = ['detail'];

    try {
      for (let i in check_fields) {
        if (row[check_fields]) {
          return false;
        }
      }
    } catch (ex) {
      return false;
    }

    return true;
  }

  removeDamageItemAtRow = (row) => (e, item) => {
    const {props} = this;
    const {damageList} = props;

    /**
     * Remove the row immediately if it's empty row
     **/
    if (this.checkEmptyRow(damageList[row])) {
      return this.props.dispatch(removeDamageItemByRowIndex({row}));
    }

    this.setState({
      deleteDamageItemModal: true,
      deleteDamageItemMessage: `ยืนยันลบรายการ "${damageList[row].detail}" ?`,
      deleteDamageItemRow: row,
    });
    // this.props.dispatch(removeDamageItemByRowIndex({row}));
  };

  handlePartSelect(row, e) {

    const selected_item = e || {};
    const itemnum = selected_item.ItemNum || 0;
    const detail = selected_item.Value || '';
    let updated = {itemnum, detail};

    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));
  }

  handleWageSelect(row, e) {

    const selected_item = e || {};
    const wage_itemnum = selected_item.ItemNum || 0;
    const detail = selected_item.Value || '';
    let updated = {wage_itemnum, detail};

    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));
  }

  handleWageDiscountSelect(row, e) {
    const selected_item = e || {};
    const discount_wage_percent = selected_item.Price;
    const updated = {discount_wage_percent};
    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));
  }

  handlePartDiscountSelect(row, e) {
    const selected_item = e || {};
    const discount_part_percent = selected_item.Price;
    const updated = {discount_part_percent};
    this.props.dispatch(updateDamageItemByRowIndex({
      row,
      updated,
    }));
  }

  onDamageItemChange = (prop, row) => (e, item) => {
    // console.log(prop, e, item);

    switch (prop) {

      case 'detail_selected':
        this.handleDetailSelect(row, e);

        break;
      case 'wage_cost_selected':
        this.handleWagePriceSelect(row, e);
        break;
      case 'part_cost_selected':
        this.handlePartPriceSelect(row, e);
        break;
      case 'price_per_unit_selected':
        this.handlePricePerUnitSelect(row, e);
        this.handlePartPriceSelect(row, e)
        break;
      case 'net_wage_cost_selected':
        this.handleNetWagePriceSelect(row, e);

        break;
      case 'damage_part_selected':
        this.handlePartSelect(row, e);

        break;
      case 'damage_wage_selected':
        this.handleWageSelect(row, e);

        break;
      case 'discount_wage_percent_selected':
        this.handleWageDiscountSelect(row, e);

        break;
      case 'discount_part_percent_selected':
        this.handlePartDiscountSelect(row, e);

        break;

      case 'discount_wage_percent':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e},
        }));
        if (e > 0) {
          this.props.dispatch(updateCar({
            discount_wage_cost: 0,
            discount_wage_percent: 0,
          }));
        }
        break;
      case 'discount_part_percent':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e},
        }));
        if (e > 0) {
          this.props.dispatch(updateCar({
            discount_part_cost: 0,
            discount_part_percent: 0,
          }));
        }
        break;
      case 'detail':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e},
        }));
        break;
      case 'wage_cost':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e.indexOf(',')!=-1?e.replace(/,/g, ''):e},
        }));
        break;
      case 'part_by':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e.target.value},
        }));
        break;
      case 'quantity':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e},
        }));
        if (this.props.car.view==1) {
          let _price_per_unit = this.props.damageList[row].part_cost==undefined?0:this.props.damageList[row].part_cost
          if (e>0)
            _price_per_unit = _price_per_unit/e
          this.handlePricePerUnit(row, _price_per_unit)
        } else if (this.props.car.view==2) {
          const _price_per_unit = this.props.damageList[row].price_per_unit==undefined?0:this.props.damageList[row].price_per_unit
          const part_cost = _price_per_unit*e
          this.handlePartPrice(row, part_cost)
        }
        break;
      case 'part_cost':
        let part_cost = e.indexOf(',')!=-1?e.replace(/,/g, ''):e
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: part_cost},
        }));
        let quantity = this.props.damageList[row].quantity==undefined?0:this.props.damageList[row].quantity
        let price_per_unit = part_cost
        if (quantity>0)
          price_per_unit = price_per_unit/quantity
        
        this.handlePricePerUnit(row, price_per_unit)
        break;
      case 'net_wage_cost':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e},
        }));
        break;
      case 'net_part_cost':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e.target.value},
        }));
        break;
      case 'discount_wage_cost':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e},
        }));
        if (e > 0) {
          this.props.dispatch(updateCar({
            discount_wage_cost: 0,
            discount_wage_percent: 0,
          }));
        }
        break;
      case 'discount_part_cost':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e},
        }));
        if (e > 0) {
          this.props.dispatch(updateCar({
            discount_part_cost: 0,
            discount_part_percent: 0,
          }));
        }
        break;
      case 'paint_flag':
      case 'fix_flag':
      case 'prefer_repair':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e.target.checked?1:0},
        }));
        break;
      case 'part_flag':
        let updated = {
          'part_flag': e.target.checked?1:0,
        };
        if (!e.target.checked) {
          updated['stock_flag'] = e.target.checked;
        }

        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated,
        }));
        break;
      case 'fixlevel':
        $('.table-responsive').css( "overflow-x", "auto" );
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e.value},
        }));
        break;  
      case 'price_per_unit':
        this.props.dispatch(updateDamageItemByRowIndex({
          row,
          updated: {[prop]: e.indexOf(',')!=-1?e.replace(/,/g, ''):e},
        }));
        const items = {Detail:'',Price:e}
        this.handlePartPriceSelect(row, items)
        break;  
    }
  };

  getRowClassName(item,index){
    if(item.prefer_repair == 1){
      return ''
    }else{
      return 'row-prefer-repair'
    }
  }

  getNumberValue(key,index) {
    let {damageList} = this.props
    let _val = damageList[index][key]
    if (_val!=undefined) {
      _val = _val.toString().replace(/,/g, '')
      return _val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
    return
  }
  
  renderTableRow(item, index) {
    const {props} = this;
    const {dispatch, damageList, car} = props;
    let {urlCache} = this.state
    return (
        <tr key={index} className={' '+this.getRowClassName(item,index) }>
          <td className={'align-middle text-center'}>{index+1}</td> {/*item.seq*/}
          <td>
            <AsyncAutoComplete
                className={'form-control form-detail'}
                style={{width: '100%', minWidth: '300px'}}
                valueField={'ItemNum'}
                labelField={'Name'}
                onSelect={this.onDamageItemChange('detail_selected', index)}
                onChange={this.onDamageItemChange('detail', index)}
                autocomplete_type={'damage'}
                value={item.detail}
                damage={{item, car}}
                inTable={true}
            />
          </td>
          {/*<td>{item.detail}</td>*/}
          <td className={'align-middle text-center'}>
            <input type={'checkbox'}
                   onChange={this.onDamageItemChange('paint_flag', index)}
                   checked={item.paint_flag == 1} />
          </td>
          <td className={'align-middle text-center'}>
            <input type={'checkbox'}
                   onChange={this.onDamageItemChange('fix_flag', index)}
                   checked={item.fix_flag == 1} />
          </td>
          <td className={'align-middle text-center'}>
            <input type={'checkbox'}
                   onChange={this.onDamageItemChange('part_flag', index)}
                   checked={item.part_flag == 1 || item.stock_flag == 1}
            />
          </td>
          <td className={'align-middle text-center'}>
            {/* <input type={'text'} value={item.quantity}
                   style={{width: '100%'}}
                   onChange={this.onDamageItemChange('quantity', index)}
                   className={'form-control text-center'} /> */}
            <InputNumber
                  className='input-number-format text-center'
                  value={item.quantity} 
                  onChange={this.onDamageItemChange('quantity', index)}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                />       
          </td>
          <td className={'align-middle text-right'}>
            <AsyncAutoComplete
                fetchOnClick={true}
                style={{width: '100%'}}
                valueField={'Price'}
                labelField={'Detail'}
                className={'form-control text-right form-detail'}
                value={this.getNumberValue('wage_cost',index)}
                onSelect={this.onDamageItemChange('wage_cost_selected',
                    index)}
                onChange={this.onDamageItemChange('wage_cost', index)}
                autocomplete_type={'wageprice'}
                damage={{item, car}}
                inTable={true}
                urlCache={urlCache}
            />
            {/* <InputNumber
                  className='input-number-format'
                  value={item.wage_cost} 
                  onChange={this.onDamageItemChange('wage_cost', index)}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                /> */}
          </td>
          <td className={'align-middle text-right'}>
            {/* <InputNumber
                  className='input-number-format'
                  value={item.part_cost} 
                  onChange={this.onDamageItemChange('part_cost', index)}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                /> */}
            <AsyncAutoComplete
                fetchOnClick={true}
                style={{width: '100%'}}
                valueField={'Price'}
                labelField={'Detail'}
                className={'form-control text-right form-detail'}
                value={this.getNumberValue('part_cost',index)}
                onSelect={this.onDamageItemChange('part_cost_selected',
                    index)}
                onChange={this.onDamageItemChange('part_cost', index)}
                autocomplete_type={'partprice'}
                damage={{item, car}}
                inTable={true}
                urlCache={urlCache}
            />    
          </td>
          <td className={'align-middle text-center'}>
            <input type={'checkbox'}
                   onChange={this.onDamageItemChange('prefer_repair', index)}
                   checked={item.prefer_repair == 1}
            />
          </td>
          <td className={'align-middle text-center'}>
            <Button bsStyle={'danger'}
                    onClick={this.removeDamageItemAtRow(index)}
            >
              <FontAwsome name={'trash'} />
            </Button>
          </td>
        </tr>
    );
  }

  renderTableDataView2() {

    if (this.props.car.view != 2) { return null; }
    return (
        <div>
          {this.renderWageTable()}
          {this.renderPartTable()}
        </div>
    );
  }

  renderRowDataTableView3() {
    let {damageList,car,fixlevel} = this.props
    let _fixlevel = []
    _fixlevel.push({label:'เลือก',value:''})
    fixlevel.forEach((item,index)=>{
      _fixlevel.push({label:item,value:item})
    })
    if (damageList.length==0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล..</td></tr>)
    } else {
      return(
        damageList.map((item,index)=>{
          return(
            <tr key={index} className={' '+this.getRowClassName(item,index)}>
              <td className={'align-middle text-center'}>{index+1}</td> {/*item.seq*/}
              <td>
                <AsyncAutoComplete
                    className={'form-control form-detail'}
                    style={{width: '100%', minWidth: '300px'}}
                    valueField={'ItemNum'}
                    labelField={'Name'}
                    onSelect={this.onDamageItemChange('detail_selected', index)}
                    onChange={this.onDamageItemChange('detail', index)}
                    autocomplete_type={'damage'}
                    value={item.detail}
                    damage={{item, car}}
                    inTable={true}
                />
              </td>
              <td className={'align-middle text-center'}>
                <input type={'checkbox'}
                      onChange={this.onDamageItemChange('paint_flag', index)}
                      checked={item.paint_flag == 1} />
              </td>
              <td className={'align-middle text-center'}>
                <input type={'checkbox'}
                      onChange={this.onDamageItemChange('fix_flag', index)}
                      checked={item.fix_flag == 1} />
              </td>
              <td className={'align-middle text-center'}>
                <input type={'checkbox'}
                      onChange={this.onDamageItemChange('part_flag', index)}
                      checked={item.part_flag == 1 || item.stock_flag == 1}
                />
              </td>
              <td className={'align-middle'}>
                <Select
                  placeholder={'เลือก'}
                  clearable={false}
                  options={_fixlevel}
                  value={item.fixlevel}
                  onChange={this.onDamageItemChange('fixlevel',index)}
                />  
              </td>
              <td className={'align-middle text-center'}>
                <input type={'checkbox'}
                      onChange={this.onDamageItemChange('prefer_repair', index)}
                      checked={item.prefer_repair == 1}
                />
              </td>
              <td className={'align-middle text-center'}>
                <Button bsStyle={'danger'}
                        onClick={this.removeDamageItemAtRow(index)}
                >
                  <FontAwsome name={'trash'} />
                </Button>
              </td>
            </tr>
          )
        })
      )
    }
  }

  renderTableDataView3() {
    const fixLevel = (
      <Popover id="popover-positioned-top" title="Fix Level">
        <FixLevelConfig isPopover={true} />
      </Popover>
    )
    if (this.props.car.view != 3) { return null; }
    return (
      <div className="table-responsive">
        <table
            className={'table table-bordered table-striped table-hover table-bordered-solid'}>
          <thead>
          <tr>
            <th className={'align-middle text-center'}
                style={{width: '60px'}}
                rowSpan={2}>ลำดับ
            </th>
            <th className={'align-middle'}
                rowSpan={2}>รายการตรวจสอบความเสียหาย
            </th>
            <th className={'align-middle text-center'}
                style={{width: '60px'}}
                rowSpan={2}>เคาะ-พ่นสี
            </th>
            <th className={'align-middle text-center'}
                style={{width: '60px'}}
                rowSpan={2}>ซ่อม
            </th>
            <th className={'align-middle text-center'}
                style={{width: '60px'}}
                rowSpan={2}>อะไหล่เปลี่ยน
            </th>
            <th style={{width: '110px'}} className={'align-middle text-center'}
                rowSpan={2}>ระดับงานซ่อม&nbsp;
                <OverlayTrigger trigger="click" placement="left" overlay={fixLevel}>
                  <FontAwsome style={{cursor:'pointer'}} name='info' />
                </OverlayTrigger>
            </th>
            <th style={{width: '60px'}} className={'align-middle text-center'}
                rowSpan={2}>ซ่อมจริง
            </th>
            <th style={{width: '50px'}} className={'align-middle text-center'}
                rowSpan={2}>ลบ
            </th>
          </tr>
          </thead>
          <tbody>
            {this.renderRowDataTableView3()}
          </tbody>
          {/* <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </tfoot> */}
        </table>
        <Row>
          <Col md={6}>
            <Button bsStyle={'success'}
                    onClick={this.addNewDamageItem(1, {part_flag: 0})}>
              + เพิ่มรายการ
            </Button>
            {' '}
            <Button bsStyle={'success'}
                    onClick={this.addNewDamageItem(10, {part_flag: 0})}>
              + เพิ่ม 10 รายการ
            </Button>
          </Col>
          <Col md={6} className={'text-right'}>
            <Form inline>
              <FormGroup>
                <ControlLabel>ผู้จัดการอะไหล่</ControlLabel>
                {' '}
                <FormControl componentClass="select"
                             value={this.props.car.partBy}
                             onChange={this.onPartByChange}>
                  <option value="garage">อู่</option>
                  <option value="branch">สาขา</option>
                  <option value="insurance">ประกัน</option>
                  <option value="customer">ลูกค้า</option>
                </FormControl>
              </FormGroup>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }

  renderWageTable() {
    let {urlCache} = this.state
    const {props} = this;
    const {dispatch, damageList, car} = props;
    const total_discount = damageList.reduce(
        (sum, item) => sum +
                       (parseFloat(item.discount_wage_cost) || 0),
        0);
    const total_wage = damageList.reduce(
        (sum, item) => sum +
                      // ((parseFloat(item.wage_cost) * parseFloat(item.quantity)) || 0),
                      ((parseFloat(item.wage_cost)) || 0),
        0);
    return (
        <div className={'table-responsive'}>
          <h4 className={'text-center'}>สรุปรายการค่าแรง</h4>
          <table
              className={'table table-bordered table-striped table-hover table-bordered-solid table-counter'}>
            <thead>
            <tr>
              <th className={'align-middle text-center'}
                  style={{width: '60px'}}>
                ลำดับ
              </th>
              <th className={'align-middle'}
                  style={{minWidth: '300px'}}>
                รายการค่าแรง + เคาะพ่นสี
              </th>
              {/* <th style={{width:'100px'}} className={'align-middle text-center'}>
                จำนวน
              </th> */}
              <th style={{width:'120px'}} className={'align-middle text-center'}>
                ราคาหน่วยละ
              </th>
              <th style={{width:'100px'}} className={'align-middle text-center'}>
                ลด %
              </th>
              <th style={{width:'150px'}} className={'align-middle text-center'}>
                ส่วนลด
              </th>
              <th style={{width:'150px'}} className={'align-middle text-center'}>
                จำนวนเงิน
              </th>
              <th style={{width:'60px'}} className={'align-middle text-center'}>ซ่อมจริง</th>
              <th style={{width:'50px'}} className={'align-middle text-center'}>ลบ</th>
            </tr>
            </thead>
            <tfoot>
            <tr>
              <th colSpan={4} className={'text-right'}>รวมราคาค่าแรง</th>
              <th className={'text-right bg-yellow'}>
                ส่วนลด{' '}
                <NumericFormat>{total_discount}</NumericFormat>
              </th>
              <th className={'text-right bg-yellow'}>
                ค่าแรง{' '}
                <NumericFormat>{total_wage-total_discount}</NumericFormat>
              </th>
              <th></th>
              <th></th>
            </tr>
            </tfoot>
            <tbody>
            {damageList.map((item, index) => {
              if (item.fix_flag != 1 && item.paint_flag != 1 && item.wage_flag != 1 && (item.wage_cost<=0||item.wage_cost==undefined||item.wage_cost==null||isNaN(item.wage_cost))) {
                return null;
              }
              return (
                  <tr key={index} className={' '+this.getRowClassName(item,index)}>                  
                    <td className={'align-middle text-center counter-row ' }></td>
                    <td>
                      <AsyncAutoComplete
                          className={'form-control form-detail'}
                          style={{width: '100%', minWidth: '400px'}}
                          valueField={'ItemNum'}
                          labelField={'Name'}
                          onSelect={this.onDamageItemChange(
                              'damage_wage_selected',
                              index)}
                          onChange={this.onDamageItemChange('detail', index)}
                          autocomplete_type={'damage_wage'}
                          value={item.detail}
                          damage={{item, car}}
                          inTable={true}
                      />
                    </td>
                    {/* <td className={'align-middle text-center td-quantity'}>
                      <InputNumber
                        className='input-number-format text-center'
                        value={item.quantity} 
                        onChange={this.onDamageItemChange('quantity', index)}
                        formatter={value =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                      />       
                    </td> */}
                    <td className={'align-middle text-right td-number'}>
                      <AsyncAutoComplete
                          fetchOnClick={true}
                          valueField={'Price'}
                          labelField={'Detail'}
                          className={'form-control text-right form-detail'}
                          onSelect={this.onDamageItemChange(
                              'wage_cost_selected',
                              index)}
                          onChange={this.onDamageItemChange('wage_cost', index)}
                          autocomplete_type={'wageprice'}
                          value={this.getNumberValue('wage_cost',index)}
                          damage={{item, car}}
                          inTable={true}
                          urlCache={urlCache}
                      />
                      {/* <InputNumber
                        className='input-number-format'
                        value={item.wage_cost} 
                        onChange={this.onDamageItemChange('wage_cost', index)}
                        formatter={value =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                      /> */}
                    </td>
                    <td className={'align-middle text-center td-percent'}>
                      {/*<input type={'text'} value={item.discount_wage_percent}
                             onChange={this.onDamageItemChange(
                                 'discount_wage_percent',
                                 index)}
                             className={'form-control text-center'} />*/}

                      <AsyncAutoComplete
                          fetchOnClick={true}
                          valueField={'Price'}
                          labelField={'Detail'}
                          className={'form-control text-center form-detail'}
                          onSelect={this.onDamageItemChange(
                              'discount_wage_percent_selected',
                              index)}
                          onChange={this.onDamageItemChange(
                              'discount_wage_percent',
                              index)}
                          autocomplete_type={'wage_discount'}
                          autocomplete_items={[
                            {Detail: '5%', Price: '5'},
                            {Detail: '10%', Price: '10'},
                            {Detail: '15%', Price: '15'},
                            {Detail: '20%', Price: '20'},
                          ]}
                          value={item.discount_wage_percent}
                          damage={{item, car}}
                          inTable={true}
                          autoWidth={true}
                      />
                    </td>
                    <td className={'align-middle text-center td-number'}>
                      {/* <input type={'text'} value={item.discount_wage_cost}
                             onChange={this.onDamageItemChange(
                                 'discount_wage_cost',
                                 index)}
                             className={'form-control text-right'} /> */}
                      <InputNumber
                        className='input-number-format'
                        value={item.discount_wage_cost} 
                        onChange={this.onDamageItemChange('discount_wage_cost', index)}
                        formatter={value =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                      />       
                    </td>
                    <td className={'align-middle text-center td-number'}>
                      <input type={'text'}
                            //  value={(parseFloat(item.wage_cost) *
                            //          parseFloat(item.quantity) - item.discount_wage_cost) || ''}
                            value={(parseFloat(item.wage_cost) - item.discount_wage_cost) || '0'}
                            readOnly
                            className={'form-control text-right'} />
                    </td>
                    <td className={'align-middle text-center'}>
                      <input type={'checkbox'}
                             onChange={this.onDamageItemChange('prefer_repair',
                                 index)}
                             checked={item.prefer_repair == 1}
                      />
                    </td>
                    <td className={'align-middle text-center'}>
                      <Button bsStyle={'danger'}
                              onClick={this.removeDamageItemAtRow(index)}
                      >
                        <FontAwsome name={'trash'} />
                      </Button>
                    </td>
                  </tr>
              );
            })}
            </tbody>
          </table>
          <Row>
            <Col md={12}>
              <Button bsStyle={'success'}
                      onClick={this.addNewDamageItem(1, {wage_flag: 1})}>
                + เพิ่มรายการ
              </Button>
              {' '}
              <Button bsStyle={'success'}
                      onClick={this.addNewDamageItem(10, {wage_flag: 1})}>
                + เพิ่ม 10 รายการ
              </Button>
            </Col>
          </Row>
        </div>
    );
  }

  renderPartTable() {
    const {props} = this;
    const {dispatch, damageList, car} = props;
    let {urlCache} = this.state
    const total_discount = damageList.reduce(
        (sum, item) => sum +
                       (parseFloat(item.discount_part_cost) || 0),
        0);

    const total_part = damageList.reduce(
        // (sum, item) => sum +
        //                ((parseFloat(item.part_cost) *
        //                  parseFloat(item.quantity)) || 0),
        (sum, item) => sum +
                       ((parseFloat(item.price_per_unit) *
                         parseFloat(item.quantity)) || 0),
        0);
    return (
        <div className={'table-responsive'}>
          <h4 className={'text-center'}>สรุปรายการอะไหล่</h4>
          <table
              className={'table table-bordered table-striped table-hover table-bordered-solid table-counter'}>
            <thead>
            <tr>
              <th className={'align-middle text-center'}
                  style={{width: '60px'}}>
                ลำดับ
              </th>
              <th className={'align-middle'}
                  style={{minWidth: '300px'}}>
                รายการอะไหล่
              </th>
              <th style={{width:'110px'}} className={'align-middle text-center'}>
                ผู้จัดอะไหล่
              </th>
              <th style={{width:'100px'}} className={'align-middle text-center'}>
                จำนวน
              </th>
              <th style={{width:'120px'}} className={'align-middle text-center'}>
                ราคาหน่วยละ
              </th>
              <th style={{width:'100px'}} className={'align-middle text-center'}>
                ลด %
              </th>
              <th style={{width:'150px'}} className={'align-middle text-center'}>
                ส่วนลด
              </th>
              <th style={{width:'150px'}} className={'align-middle text-center'}>
                จำนวนเงิน
              </th>
              <th style={{width:'60px'}} className={'align-middle text-center'}>ซ่อมจริง</th>
              <th style={{width:'50px'}} className={'align-middle text-center'}>ลบ</th>
            </tr>
            </thead>
            <tfoot>
            <tr>
              <th colSpan={6} className={'text-right'}>รวมราคาค่าอะไหล่</th>
              <th className={'text-right bg-yellow'}>
                ส่วนลด{' '}
                <NumericFormat>{total_discount}</NumericFormat>
              </th>
              <th className={'text-right bg-yellow'}>
                ค่าอะไหล่{' '}
                <NumericFormat>{total_part-total_discount}</NumericFormat>
              </th>
              <th></th>
              <th></th>
            </tr>
            </tfoot>
            <tbody>
            {damageList.map((item, index) => {
              if (item.part_flag != 1 && item.stock_flag != 1 && item.parts_flag != 1 && (item.part_cost<=0||item.part_cost==undefined||item.part_cost==null||isNaN(item.part_cost))) {
                return null;
              }
              let discount_part_cost = item.discount_part_cost!=undefined?item.discount_part_cost:0
              return (
                <tr key={index} className={' '+this.getRowClassName(item,index)}>
                    <td className={'align-middle text-center counter-row ' }></td>
                    <td>
                      <AsyncAutoComplete
                          className={'form-control form-detail'}
                          style={{width: '100%', minWidth: '300px'}}
                          valueField={'ItemNum'}
                          labelField={'Name'}
                          onSelect={this.onDamageItemChange(
                              'damage_wage_selected',
                              index)}
                          onChange={this.onDamageItemChange('detail', index)}
                          autocomplete_type={'damage_part'}
                          value={item.detail}
                          damage={{item, car}}
                          inTable={true}
                      />
                    </td>
                    <td className={'align-middle text-right td-number'}>
                      <FormControl componentClass="select"
                                   style={{width: '100%', minWidth: '100px'}}
                                   value={item.part_by}
                                   onChange={this.onDamageItemChange('part_by',
                                       index)}
                      >
                        <option value="">โปรดระบุ</option>
                        <option value="garage">อู่</option>
                        <option value="branch">สาขา</option>
                        <option value="insurance">ประกัน</option>
                        <option value="customer">ลูกค้า</option>
                      </FormControl>
                    </td>
                    <td className={'align-middle text-center td-quantity'}>
                      {/* <input type={'text'} value={item.quantity}
                             style={{width: '100%'}}
                             onChange={this.onDamageItemChange('quantity',
                                 index)}
                             className={'form-control text-center'} /> */}
                      <InputNumber
                        className='input-number-format text-center'
                        value={item.quantity} 
                        onChange={this.onDamageItemChange('quantity', index)}
                        formatter={value =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                      />       
                    </td>
                    <td className={'align-middle text-right td-number'}>
                      {/* <InputNumber
                        className='input-number-format'
                        value={item.part_cost}  
                        onChange={this.onDamageItemChange('part_cost', index)}
                        formatter={value =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                      /> */}
                      <AsyncAutoComplete
                        fetchOnClick={true}
                        style={{width: '100%'}}
                        valueField={'Price'}
                        labelField={'Detail'}
                        className={'form-control text-right form-detail'}
                        value={this.getNumberValue('price_per_unit',index)}
                        onSelect={this.onDamageItemChange('price_per_unit_selected',
                            index)}
                        onChange={this.onDamageItemChange('price_per_unit', index)}
                        autocomplete_type={'partprice'}
                        damage={{item, car}}
                        inTable={true}
                        urlCache={urlCache}
                      />
                    </td>
                    <td className={'align-middle text-center td-percent'}>
                      {/*<input type={'text'} value={item.discount_part_percent}
                             onChange={this.onDamageItemChange(
                                 'discount_part_percent',
                                 index)}
                             className={'form-control text-center'} />*/}
                      <AsyncAutoComplete
                          fetchOnClick={true}
                          valueField={'Price'}
                          labelField={'Detail'}
                          className={'form-control text-center form-detail'}
                          onSelect={this.onDamageItemChange(
                              'discount_part_percent_selected',
                              index)}
                          onChange={this.onDamageItemChange(
                              'discount_part_percent',
                              index)}
                          autocomplete_type={'part_discount'}
                          autocomplete_items={[
                            {Detail: '5%', Price: '5'},
                            {Detail: '10%', Price: '10'},
                            {Detail: '15%', Price: '15'},
                            {Detail: '20%', Price: '20'},
                          ]}
                          value={item.discount_part_percent}
                          damage={{item, car}}
                          inTable={true}
                          autoWidth={true}
                      />
                    </td>
                    <td className={'align-middle text-center td-number'}>
                      {/* <input type={'text'} value={item.discount_part_cost}
                             onChange={this.onDamageItemChange(
                                 'discount_part_cost',
                                 index)}
                             className={'form-control text-right'} /> */}
                      <InputNumber
                        className='input-number-format'
                        value={item.discount_part_cost} 
                        onChange={this.onDamageItemChange('discount_part_cost', index)}
                        formatter={value =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                      />       
                    </td>
                    <td className={'align-middle text-center td-number'}>
                      <input type={'text'}
                             value={(parseFloat(item.price_per_unit)*parseFloat(item.quantity)-parseFloat(discount_part_cost)) || '0'}
                             readOnly
                             className={'form-control text-right'} />
                    </td>
                    <td className={'align-middle text-center'}>
                      <input type={'checkbox'}
                             onChange={this.onDamageItemChange('prefer_repair',
                                 index)}
                             checked={item.prefer_repair == 1}
                      />
                    </td>
                    <td className={'align-middle text-center'}>
                      <Button bsStyle={'danger'}
                              onClick={this.removeDamageItemAtRow(index)}
                      >
                        <FontAwsome name={'trash'} />
                      </Button>
                    </td>
                  </tr>
              );
            })}
            </tbody>
          </table>
          <Row>
            {/*<Col md={12}>
              <Button bsStyle={'success'}
                      onClick={this.addNewDamageItem(1, {part_flag: 1})}>
                + เพิ่มรายการ
              </Button>
              {' '}
              <Button bsStyle={'success'}
                      onClick={this.addNewDamageItem(10, {part_flag: 1})}>
                + เพิ่ม 10 รายการ
              </Button>
            </Col>*/}
            <Col md={6}>
              <Button bsStyle={'success'}
                      onClick={this.addNewDamageItem(1, {part_flag: 1})}>
                + เพิ่มรายการ
              </Button>
              {' '}
              <Button bsStyle={'success'}
                      onClick={this.addNewDamageItem(10, {part_flag: 1})}>
                + เพิ่ม 10 รายการ
              </Button>
            </Col>
            <Col md={6} className={'text-right'}>
              <Form inline>
                <FormGroup>
                  <ControlLabel>ผู้จัดการอะไหล่</ControlLabel>
                  {' '}
                  <FormControl componentClass="select"
                               value={this.props.car.partBy}
                               onChange={this.onPartByChange}>
                    <option value="garage">อู่</option>
                    <option value="branch">สาขา</option>
                    <option value="insurance">ประกัน</option>
                    <option value="customer">ลูกค้า</option>
                  </FormControl>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </div>
    );
  }

  renderSummaryView() {
    const {props} = this;
    const {dispatch, damageList, car} = props;

    const total_wage = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.wage_cost) || 0), 0);
        // sum + (parseFloat(item.wage_cost) * parseFloat(item.quantity) || 0), 0);

    const total_part = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.part_cost) || 0), 0);
        // sum + (parseFloat(item.price_per_unit) * parseFloat(item.quantity) - parseFloat(item.discount_part_cost) || 0), 0);

    const total_discount_wage = parseFloat(car.discount_wage_cost) ||
                                damageList.reduce((sum, item) =>
                                    sum +
                                    (parseFloat(item.discount_wage_cost) || 0),
                                    0);

    const total_discount_part = parseFloat(car.discount_part_cost) ||
                                damageList.reduce((sum, item) =>
                                    sum +
                                    (parseFloat(item.discount_part_cost) || 0),
                                    0);

    const total_discount_wage_percent = car.discount_wage_percent ||
                                        (((total_discount_wage / total_wage) *
                                          100) || 0).toFixed(2);
    const total_discount_part_percent = car.discount_part_percent ||
                                        (((total_discount_part / total_part) *
                                          100) || 0).toFixed(2);

    return (
        <div className={'text-right'}>
          <PaddedRow>
            <Col md={12}>
              จำนวนเงินค่าแรง <StaticWidthNumeric>{total_wage}</StaticWidthNumeric> บาท
            </Col>
          </PaddedRow>
          <PaddedRow>
            <Col md={12}>
              จำนวนเงินค่าอะไหล่ <StaticWidthNumeric>{total_part}</StaticWidthNumeric> บาท
            </Col>
          </PaddedRow>
          <PaddedRow>
            <Col md={12}>
              ยอดรวม <StaticWidthNumeric>
              {total_part + total_wage}
            </StaticWidthNumeric> บาท
            </Col>
          </PaddedRow>
          <PaddedRow>
            <Col md={12} className={'form-inline'}>
              ส่วนลดค่าแรง{' '}
              <FormControl type={'text'} size={10}
                           className={'text-right'}
                           value={total_discount_wage_percent}
                           onChange={this.handleTotalWageDiscountPercent} />{' '}
              %{' '}
              <FormControl type={'text'} size={10}
                           className={'text-right'}
                           value={total_discount_wage}
                           onChange={this.handleTotalWageDiscountCost} /> บาท
            </Col>
          </PaddedRow>
          <PaddedRow>
            <Col md={12} className={'form-inline'}>
              ส่วนลดค่าอะไหล่{' '}
              <FormControl type={'text'} size={10}
                           className={'text-right'}
                           value={total_discount_part_percent}
                           onChange={this.handleTotalPartDiscountPercent} />{' '}
              %{' '}

              <FormControl type={'text'} size={10}
                           className={'text-right'}
                           value={total_discount_part}
                           onChange={this.handleTotalPartDiscountCost} /> บาท
            </Col>
          </PaddedRow>
          <PaddedRow>
            <Col md={12}>
              ยอดรวมหลังหักส่วนลด <StaticWidthNumeric>
              {(total_part + total_wage) -
               (total_discount_wage + total_discount_part)}
            </StaticWidthNumeric> บาท
            </Col>
          </PaddedRow>
          <PaddedRow>
            <Col md={12}><strong>
              ยอดรวมสุทธิ <StaticWidthNumeric>
              {(total_part + total_wage) -
               (total_discount_wage + total_discount_part)}
            </StaticWidthNumeric> บาท
            </strong></Col>
          </PaddedRow>
        </div>
    );
  }

  handleTotalWageDiscountPercent = (e) => {

    const {props} = this;
    const {dispatch, damageList, car} = props;

    const total_wage = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.net_wage_cost || item.wage_cost) || 0), 0);

    const total_discount_wage = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.discount_wage_cost) || 0), 0);

    if (total_discount_wage > 0) {
      this.setState({discountModal: true});
      return;
    }

    const discount_wage_percent = e.target.value;
    const discount_wage_cost = (total_wage *
                                parseFloat(discount_wage_percent) /
                                100).toFixed(2);
    dispatch(updateCar({
      discount_wage_percent,
      discount_wage_cost,
    }));
  };

  handleTotalWageDiscountCost = (e) => {

    const {props} = this;
    const {dispatch, damageList, car} = props;

    const total_wage = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.net_wage_cost || item.wage_cost) || 0), 0);

    const total_discount_wage = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.discount_wage_cost) || 0), 0);

    if (total_discount_wage > 0) {
      this.setState({discountModal: true});
      return;
    }

    const discount_wage_cost = e.target.value;
    const discount_wage_percent = (((parseFloat(discount_wage_cost) /
                                     total_wage) * 100) || 0).toFixed(2);
    dispatch(updateCar({
      discount_wage_percent,
      discount_wage_cost,
    }));
  };

  handleTotalPartDiscountPercent = (e) => {

    const {props} = this;
    const {dispatch, damageList, car} = props;

    const total_part = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.net_part_cost || item.part_cost) || 0), 0);

    const total_discount_part = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.discount_part_cost) || 0), 0);

    if (total_discount_part > 0) {
      this.setState({discountModal: true});
      return;
    }

    const discount_part_percent = e.target.value;
    const discount_part_cost = (total_part *
                                parseFloat(discount_part_percent) /
                                100).toFixed(2);
    dispatch(updateCar({
      discount_part_percent,
      discount_part_cost,
    }));

  };

  handleTotalPartDiscountCost = (e) => {

    const {props} = this;
    const {dispatch, damageList, car} = props;

    const total_part = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.net_part_cost || item.part_cost) || 0), 0);

    const total_discount_part = damageList.reduce((sum, item) =>
        sum + (parseFloat(item.discount_part_cost) || 0), 0);

    if (total_discount_part > 0) {
      this.setState({discountModal: true});
      return;
    }

    const discount_part_cost = e.target.value;
    const discount_part_percent = (((parseFloat(discount_part_cost) /
                                     total_part) * 100) || 0).toFixed(2);
    dispatch(updateCar({
      discount_part_percent,
      discount_part_cost,
    }));
  };

  render() {
    return (
        <Box loading={this.props.loading.damage}>
          <Box.Body>
            <div className={'car-damage-list'}>
              <Row>
                <Col md={12}>
                  <div className={'pull-right'}>
                    {this.renderDocMenu()}
                  </div>
                  <h3>
                    <FontAwsome name={'warning'} className={'text-primary'} />
                    {' '}
                    รายการความเสียหาย
                    {'   '}
                    <span>
                      <label className="small">
                        <input type={'radio'} value={1}
                               name={'table-view'}
                               onChange={this.changeTableView}
                               checked={this.props.car.view == 1} />
                        {' '}แสดงแบบรวมรายการ
                      </label>{'  '}
                      <label className="small">
                        <input type={'radio'} value={2}
                               name={'table-view'}
                               onChange={this.changeTableView}
                               checked={this.props.car.view == 2} />
                        {' '}แสดงแยกค่าแรงและค่าอะไหล่
                      </label>{'  '}  
                      <label className="small">
                        <input type={'radio'} value={3}
                               name={'table-view'}
                               onChange={this.changeTableView}
                               checked={this.props.car.view == 3} />
                        {' '}แสดงระดับงานซ่อม
                      </label>
                    </span>
                  </h3>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  {this.renderTableDataView1()}
                  {this.renderTableDataView2()}
                  {this.renderTableDataView3()}
                  {this.renderSummaryView()}
                </Col>
              </Row>
            </div>
            <ConfirmPopup show={this.state.deleteDamageItemModal}
                          title={'ยืนยัน'}
                          message={this.state.deleteDamageItemMessage}
                          onConfirm={this.removeDamageItem}
                          onHide={() => {
                            this.setState({deleteDamageItemModal: false});
                          }}
            />

          </Box.Body>
          <Modal show={this.state.discountModal}>
            <Modal.Header>
              แจ้งเตือน
            </Modal.Header>
            <Modal.Body>
              ท่านได้ใส่ข้อมูลส่วนลดค่าแรงในตารางเรียบร้อยแล้ว
              หากต้องการแก้ไขข้อมูลให้ลบส่วนลดในตาราง
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={(e) => {
                this.setState({discountModal: false});
              }}><FontAwsome name={'close'} /> ยกเลิก</Button>
            </Modal.Footer>
          </Modal>
        </Box>
    );
  }

  renderDocMenu() {
    let title = (<span><i className="fa  fa-edit"></i>&nbsp;สร้างเอกสาร</span>);
    return (
        <div className="margin box-tools pull-right">
          <ButtonToolbar>
            <SplitButton id={'document-menu'} bsStyle={'primary'} title={title}
                         onSelect={this.onMenuItemSelect.bind(this)}>
              <MenuItem eventKey="quotation"><FontAwsome name="file-text-o"
                                                         className="text-green" />ใบเสนอราคา</MenuItem>
              <MenuItem eventKey="invoice"><FontAwsome name="file-text-o"
                                                       className="text-green" />ใบแจ้งหนี้</MenuItem>
              <MenuItem eventKey="receipt"><FontAwsome name="file-text-o"
                                                       className="text-green" />ใบเสร็จรับเงิน</MenuItem>
              <MenuItem eventKey="taxinvoice"><FontAwsome name="file-text-o"
                                                          className="text-green" />ใบกำกับภาษี</MenuItem>
              <MenuItem eventKey="cashbill"><FontAwsome name="file-text-o"
                                                        className="text-green" />บิลเงินสด</MenuItem>
              <MenuItem divider />
              <MenuItem eventKey="exportstock"><FontAwsome name="file-text-o"
                                                           className="text-green" />ใบเบิกคลังสินค้า</MenuItem>
              <MenuItem divider />
              <MenuItem eventKey="purchaseorder"><FontAwsome name="file-text-o"
                                                             className="text-green" />ใบสั่งซื้อ</MenuItem>
            </SplitButton>
          </ButtonToolbar>
        </div>
    );
  }

  onMenuItemSelect(eventKey, event) {
    // console.log('eventKey', eventKey, event);
    let docNameConst = {
      invoice: 'ใบแจ้งหนี้',
      receipt: 'ใบเสร็จรับเงิน',
      taxinvoice: 'ใบกำกับภาษี',
      cashbill: 'บิลเงินสด',
    };
    let {workNo} = this.props;
    if ('quotation' === eventKey) {
      window.request_quotation();
    } else if (['invoice', 'receipt', 'taxinvoice', 'cashbill'].includes(
        eventKey)) {
      //window.request_cash_bill();
      //this.setState({showNewDoc:true})
      var fn = window['request_'+eventKey];          
      if (typeof fn === 'function') {              
          fn.apply(undefined, []);
      } 

      // this.refs.newdoc.loadData({
      //   workNo: workNo, docType: eventKey, docName: docNameConst[eventKey],
      //   onRowClick: function(docNo) {
      //     if (process.env.NODE_ENV == 'development') {
      //       alert('show_cashbill_doc:' + docNo);
      //     } else {
      //       //window.show_cashbill_doc(docNo);
      //       var fn = window['show_' + eventKey + '_doc'];
      //       if (typeof fn === 'function') {
      //         fn.apply(undefined, [docNo]);
      //       }

      //     }
      //   }, onNewDoc: function(filterType, priceOnListType) {
      //     if (process.env.NODE_ENV == 'development') {
      //       alert('onNewDoc:' + filterType + ',' + priceOnListType);
      //     } else {
      //       var fn = window['create_' + eventKey + '_doc'];
      //       if (typeof fn === 'function') {
      //         fn.apply(undefined, [workNo, filterType, priceOnListType]);
      //       }
      //     }
      //   },
      // });
    } else if ('exportstock' === eventKey) {
      // window.request_export_stock();

      let that = this;
      WorkdocStore.loadWorkdocFixingList(this.props.workNo, function(result) {

        let data = result.data.partlist.map((item, index) => {
          item.description = item.detail;
          return item;
        });

        const yTh = parseInt(Moment().format('YYYY')) + 543;
        const date = Moment().
            format('L LT').
            replace(Moment().format('YYYY'), yTh);
        let export_stock_flag = [];
        data.forEach(element => {
          if (element.export_stock_flag == '1') {
            export_stock_flag.push({
              itemnum: element.itemnum,
            });
          }
        });
        let displayBtnStockOutView = 'none';
        let btnDisabled = false;
        if (export_stock_flag.length > 0) { // export_stock_flag.length==data.length
          displayBtnStockOutView = '';
        }
        if (export_stock_flag.length == data.length) {
          displayBtnStockOutView = '';
          btnDisabled = true;
        }
        that.setState({
          createDate: date,
          showStockOut: true,
          dataStockOut: data,
          displayBtnStockOutView: displayBtnStockOutView,
          btnDisabled: btnDisabled,
        });

      });
    } else if ('purchaseorder' === eventKey) {
      window.request_purchase();
    }
  }
}

export default connect(
    (state, props) => ({...state, ...props}),
)(DamageList);



// WEBPACK FOOTER //
// ./src/component/element/CarDamageForm/DamageList/DamageList.js